import fetch from '@/api/fetch'
export default{
    data(){
        return{
            freeData: {
                freeInitInterval: null, // 初始化间隔
                freeMaxPerson: null, //最大人数(免费传)
            },
            proData: {
                proInitInterval: null, // 初始化间隔（付费传)
                proLoopTimes: null, // 最大重置次数(付费传)
            },
            orgRuleData:{
                proInitInterval: null, // 初始化间隔（付费传)
                proLoopTimes: null, // 最大重置次数(付费传)
            },
            orgListData:{},
            dialogData: {
                titleText: '',
                addLxDialog: false,
                dialogWidth: '460px'
            },
            loading: false,
            searchContent: '',
            orgList: [],
            teamTableHeader:  [
                {prop: 'sortNo', label: this.$t('adminSet.XH'),width: '80'},
                {prop: 'orgName', label: this.$t('adminSet.JGMC')},
                {prop: 'orgCode', label: this.$t('adminSet.JGDM')},
                {prop: 'proInitInterval', label: this.$t('adminSet.CSHJG')},
                {prop: 'proLoopTimes', label: this.$t('adminSet.XHSX')},
                {prop: 'operation', label:  this.$t('adminSet.CZ'),SlotType:{
                    buttons:[
                      {
                        name: this.$t('adminSet.XG'),
                        emitName: 'modify' // 事件Type 必传
                      }
                    ]
                }}
            ],
            total: 0,
            pageNo: 1
        }
    },
    computed:{
        queryData(){
            return JSON.parse(sessionStorage.getItem('queryData'))
        }
    },
    created() {
        this.getList();
        this.getRuleDataFreePro() // 限制数据
    },
    methods: {
        // 列表数据
        getList(type){
            this.loading = true
            let { professionId, subjectId } = this.queryData
            if(type != 'pageNo' && this.searchContent){
                this.pageNo = 1
            }
            let params = {
                professionId,
                subjectId,
                pageNo: this.pageNo,
                limitSize: 100,
                searchContent: this.searchContent
            }
            fetch.ruleOrgList(params).then(res=>{
                if(res.code == 0){
                    this.total = res.data.total
                    this.orgList = res.data.records.map((item, index)=>({...item, sortNo: ((++index) + ((this.pageNo -1) * 100))}))
                    this.loading = false
                }else{
                    this.$notify({ title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.HQSJSB'), type: 'error' });
                }
            })
        },
        // 免费付费限制数据
        getRuleDataFreePro(){
            let { professionId, subjectId } = this.queryData
            fetch.ruleParamGet({professionId, subjectId}).then(res=>{
                if(res.code == 0){
                    sessionStorage.setItem('ruleParamData', JSON.stringify(res.data))
                    this.freeData = {...res.data}
                    this.proData = {...res.data}
                }else{
                    this.$notify({ title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.HQSJSB'), type: 'error' });
                }
            })
        },
        blurInput(type){
            let ruleParamData = JSON.parse(sessionStorage.getItem('ruleParamData'))
            if(type === 'free'){
                // 免费
                let { freeInitInterval, freeMaxPerson  } = this.freeData
                if(ruleParamData.freeInitInterval == freeInitInterval && ruleParamData.freeMaxPerson == freeMaxPerson){
                    return false
                }else if(freeInitInterval < 0 || freeMaxPerson < 0){
                    this.resetRuleData()
                    this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.SJXDY'), type: 'error'})
                    return false
                }else if(isNaN(freeInitInterval) || isNaN(freeMaxPerson)){
                    this.resetRuleData()
                    this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.QSRSZ'), type: 'error'})
                    return false
                }else if(freeMaxPerson > 200){
                    this.resetRuleData()
                    this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.MFZDXZW'), type: 'error'})
                    return false
                }
            }else{
                // 产品
                
                let { proLoopTimes, proInitInterval } = this.proData

                if(ruleParamData.proLoopTimes == proLoopTimes && ruleParamData.proInitInterval == proInitInterval){
                    return false
                }else if(proLoopTimes < 0 || proInitInterval < 0){
                    this.resetRuleData()
                    this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.SJXDY'), type: 'error'})
                    return false
                }else if(isNaN(proLoopTimes) || isNaN(proInitInterval)){
                    this.resetRuleData()
                    this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.QSRSZ'), type: 'error'})
                    return false
                }
            }
            // console.log(type)
            this.$confirm(this.$t('adminSet.SFQRXG'), this.$t('adminSet.TS'), {
                confirmButtonText: this.$t('adminSet.QD'),
                cancelButtonText: this.$t('adminSet.QX'),
                type: 'warning'
            }).then(() => {
                this.ruleParamSave(type)
            }).catch(() => {
                this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.QXXG'), type: 'info'})
                this.resetRuleData()
            });
        },
        // 重置数据
        resetRuleData(){
            let ruleParamData = JSON.parse(sessionStorage.getItem('ruleParamData'))
            this.freeData = {...ruleParamData}
            this.proData = {...ruleParamData}
        },
        ruleParamSave(){
            let { id, freeInitInterval, freeMaxPerson } = this.freeData
            let { proLoopTimes, proInitInterval } = this.proData
            let { professionId, subjectId } = JSON.parse(sessionStorage.getItem('queryData'))
            let params = {
                id,
                professionId,
                subjectId,
                freeInitInterval,
                freeMaxPerson,
                proLoopTimes,
                proInitInterval
            }
            // if(type === 'free'){
            //     // 收费设置
            //     params['freeInitInterval'] = freeInitInterval
            //     params['freeMaxPerson'] = freeMaxPerson
            // }else{
            //     let { proLoopTimes, proInitInterval } = this.proData
            //     // 免费设置
            //     params['proInitInterval'] = proInitInterval
            //     params['proLoopTimes'] = proLoopTimes
            // }
            fetch.ruleParamSave(params).then(res=>{
                if(res.code == 0){
                   this.$notify({title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.XGCG'), type: 'success'})
                   this.getRuleDataFreePro()
                }else{
                    this.$notify({title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.XGSB'), type: 'error'})
                }
            })
        },
        // 重置
        resetPro(type){
            let getInitData = {
                proInitInterval:{
                    infoText: this.$t('adminSet.CZCSHJG'),
                    fetchFun: 'ruleOrgResetInit'
                },
                proLoopTimes: {
                    infoText: this.$t('adminSet.CZXHSX'),
                    fetchFun: 'ruleOrgResetLoop'
                }
            }
            // if(type == 'proInitInterval'){
            //     // /重置初始化间隔
                
            // }else{
            //     // 重置循环上限
            // }
            this.$confirm(`${this.$t('adminSet.SFQR')}${getInitData[type].infoText}?`, this.$t('adminSet.TS'), {
                confirmButtonText: this.$t('adminSet.QD'),
                cancelButtonText: this.$t('adminSet.QX'),
                type: 'warning'
            }).then(() => {
                let { professionId, subjectId } = JSON.parse(sessionStorage.getItem('queryData'))
                fetch[getInitData[type].fetchFun]({
                    professionId,
                    subjectId
                }).then(res=>{
                    if(res.code == 0){
                        this.$notify({title: this.$t('adminSet.CZ'), message: `${getInitData[type].infoText}${this.$t('adminSet.CG')}`, type: 'success'})
                        this.getRuleDataFreePro()
                    }else{
                        this.$notify({title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.CZSB'), type: 'error'})
                    }
                })
            }).catch(() => {
                this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.QXCZ'), type: 'info'})
                this.resetRuleData()
            });
        },
        saveOrgRule(){
            let { proLoopTimes, proInitInterval, id } = this.orgRuleData
            let orgListData = this.orgListData
            if(orgListData.proLoopTimes == proLoopTimes && orgListData.proInitInterval == proInitInterval){
                this.dialogData.addLxDialog = false
                return false
            }else if(isNaN(proLoopTimes) || isNaN(proInitInterval)){
                this.$notify({title: this.$t('adminSet.CZ'), message: this.$t('adminSet.QSRSZ'), type: 'error'})
                return false
            }
            let params = { proLoopTimes, proInitInterval, id }
            fetch.ruleOrgResetEdit(params).then(res=>{
                if(res.code == 0){
                   this.$notify({title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.XGCG'), type: 'success'})
                   this.getList()
                   this.dialogData.addLxDialog = false
                }else{
                    this.$notify({title: this.$t('adminSet.CZ'), message: res.msg || this.$t('adminSet.XGSB'), type: 'error'})
                    this.dialogData.addLxDialog = false
                }
            })
        },
        operation(type, rowData){
            if(type == 'modify'){
                this.orgRuleData = {...rowData}
                this.orgListData = {...rowData}
                this.dialogData.titleText = rowData.orgName
                this.dialogData.addLxDialog = true
            }
        }
    },
}